import axios from 'axios';

const URL = 'https://api.openweathermap.org/data/2.5/forecast';
const API_KEY = 'f33a484cf794d08d0148764789aaba32';

export const fetchForecast = async (query) => {
    try {
        const { data } = await axios.get(URL, {
            params: {
                q: query,
                lang: 'es',
                units: 'metric',
                APPID: API_KEY,
            }
        });
        
        // Filtrar para obtener solo 1 predicción por día (mediodía)
        const dailyForecasts = data.list.filter(item => 
            item.dt_txt.includes('12:00:00')
        ).slice(0, 5);
        
        return { data: dailyForecasts, error: null };
    } catch (err) {
        if (err.response && err.response.status === 404) {
            return { 
                data: null, 
                error: `Ciudad "${query}" no encontrada. Comprueba el nombre e inténtalo de nuevo.` 
            };
        }
        return { 
            data: null, 
            error: 'Error al conectar con el servidor. Inténtalo más tarde.' 
        };
    }
};